module.exports = __webpack_public_path__ + "img/131.10.1e6a12b5.png";